import React, { useEffect, useState } from "react";
import { API } from "../../pages/backend";
import { useFlutterwave } from "flutterwave-react-v3";
import {
  Box,
  Button,
  Card,
  Container,
  Grid,
  Typography,
  TextField,
  Select,
  MenuItem,
} from "@mui/material";
// import Footer from "../Footer";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import ProceedModal from "../ProceedModal";
import { styled } from "@mui/system";
import ProceedModalPrint from "../ProceedModalPrint";
import Swal from "sweetalert2";
import Layout from "../../reusables/layout/layout";
import InputField from "../forms/input/TextInput/InputField";
import { useDispatch, useSelector } from "react-redux";
import BulkPublic from "../BulkPublic";
import IndividualPublic from "../IndividualPublic";
import showModal from "../../store/reducers/modal";
// import { examDetailsChanger } from '../../partials';
import { examPrices } from "../../partials/examboardprices/examprices";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { setTransactionDetails } from "../../store/reducers/transactionDetails";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import data from "../dropDown";

const RequsitionService = ({ examName, examType }) => {
  const { Tedac } = data;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const user = useSelector((state) => state.user);
  const user = useSelector((state) => state.user.data.details);
  console.log(user);
  const invoiceGenerate = () => {
    const priceInt = 10000;
    const generatedInvoiceData = {
      payerName: user.contactPerson,
      price: priceInt,
      examType,
      examName,
    };
    dispatch(setTransactionDetails(generatedInvoiceData));
    navigate("/Invoice");
  };

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    middleName: "",
    email: "",
    payerId: "",
    certification: "",
  });

  const [errors, setErrors] = useState({});
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value.trim() });
  };

  const handleGenerateInvoice = () => {
    const requiredFields = [
      // Other required fields...
      // "firstName",
      // "middleName",
      // "lastName",
      // "payerId",
      // "email",
      "certification",
    ];
    const fieldNameMap = {
      // firstName: "First Name",
      // middleName: "Middle Name",
      // lastName: "Last Name",
      // payerId: "Payer ID  ",
      // email: "Email",
      certification: "Field",
      // Mapping for other fields...
    };
    const validateEmail = (email) => {
      const regex =
        /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return regex.test(String(email).toLowerCase());
    };
    let newErrors = {};
    requiredFields.forEach((field) => {
      if (!formData[field].trim()) {
        newErrors[field] = `${fieldNameMap[field]} is required`;
      }
      //  else if (field === "email" && !validateEmail(formData[field])) {
      //   newErrors[field] = "Invalid email address";
      // }
    });
    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      console.log("Navigating to Invoice");
      invoiceGenerate();
    } else {
      console.log("Errors:", newErrors);
    }
  };

  return (
    <div>
      <Layout>
        <Card className="model-card" elevation={5}>
          <Box
            component="form"
            noValidate
            autoComplete="off"
            className="bece-form-left"
            onSubmit={(e) => e.preventDefault()}
          >
            <div style={{ padding: "0px 5px" }}></div>
            <Typography
              variant="h5"
              align="center"
              sx={{ paddingTop: "1.5rem", fontWeight: "bold" }}
            >
              {examType}
            </Typography>

            <Container sx={{ mt: 5 }}>
              <form>
                <div>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        name="certification"
                        label="Select Certification"
                        value={formData.certification}
                        onChange={handleChange}
                        select
                        style={{
                          width: "100%",
                          marginTop: "2.5rem",
                        }}
                      >
                        {Tedac.map((tedacItem) => (
                          <MenuItem key={tedacItem.cert} value={tedacItem.cert}>
                            {tedacItem.cert}
                          </MenuItem>
                        ))}
                      </TextField>
                      {errors.certification && (
                        <Typography color="error">
                          {errors.certification}
                        </Typography>
                      )}
                    </Grid>
                    <Grid item xs={6}>
                      <InputField
                        name="Amount"
                        label="Fee Per Certification"
                        type="Amount"
                        value="₦10,000"
                        disabled
                        onChange={handleChange}
                        style={{ height: "100%" }}
                      />
                    </Grid>
                  </Grid>
                </div>
                <div>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <InputField
                        name="firstName"
                        label="First Name"
                        type="text"
                        placeholder="First Name"
                        onChange={handleChange}
                        value={user.firstName}
                      />
                      {errors.firstName && (
                        <Typography color="error">
                          {errors.firstName}
                        </Typography>
                      )}
                    </Grid>
                    <Grid item xs={6}>
                      <InputField
                        name="middleName"
                        label="Middle Name"
                        type="middleName"
                        placeholder="Middle Name"
                        onChange={handleChange}
                        value={formData.middleName}
                        style={{ height: "100%" }}
                      />
                      {errors.middleName && (
                        <Typography color="error">
                          {errors.middleName}
                        </Typography>
                      )}
                    </Grid>
                  </Grid>
                </div>
                <div>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <InputField
                        name="lastName"
                        label="Last Name"
                        type="lastName"
                        placeholder="Last Name"
                        onChange={handleChange}
                        value={user.lastName}
                        style={{ height: "100%" }}
                      />
                      {errors.lastName && (
                        <Typography color="error">{errors.lastName}</Typography>
                      )}
                    </Grid>
                    <Grid item xs={6}>
                      <InputField
                        name="email"
                        label="Email"
                        type="email"
                        placeholder="Email"
                        onChange={handleChange}
                        value={user.email}
                        style={{ height: "100%" }}
                      />
                      {errors.email && (
                        <Typography color="error">{errors.email}</Typography>
                      )}
                    </Grid>
                  </Grid>
                </div>
                <div>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <InputField
                        name="LASSRA"
                        label="LASSRA"
                        type="LASSRA"
                        placeholder="LASSRA"
                        onChange={handleChange}
                        style={{ height: "100%" }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <InputField
                        name="payerId"
                        label="Payer ID"
                        type="payerId"
                        placeholder="Payer ID"
                        onChange={handleChange}
                        value={user.payerId}
                        style={{ height: "100%" }}
                      />
                      {errors.payerId && (
                        <Typography color="error">{errors.payerId}</Typography>
                      )}
                    </Grid>
                  </Grid>
                </div>

                <div style={{ marginTop: "3rem", display: "flex" }}>
                  <Button
                    color="success"
                    variant="contained"
                    sx={{
                      textTransform: "inherit",
                      fontWeight: "bold",
                      marginRight: "2rem",
                    }}
                    onClick={handleGenerateInvoice}
                  >
                    Generate Invoice
                  </Button>

                  <Link
                    component="button"
                    to="/"
                    sx={{ color: "#000", textDecoration: "none" }}
                  >
                    <Button
                      variant="text"
                      sx={{
                        textTransform: "inherit",
                        fontWeight: "bold",
                        ml: "5px",
                        color: "black",
                      }}
                    >
                      Go back
                    </Button>
                  </Link>
                </div>
              </form>
            </Container>
          </Box>
          <Box compnent="div" className="model-form-right">
            <Typography
              variant="h4"
              align="center"
              sx={{ color: "#ffffff", fontWeight: "bold" }}
            >
              Lagos State Exam Board
            </Typography>
            <img src={"/assets/images/laags.png"} alt="logo" />
            <Typography
              variant="h4"
              align="center"
              sx={{ color: "white", fontWeight: "bold", mb: 3 }}
            >
              {examName}
            </Typography>
            <Typography
              variant="body2"
              align="center"
              sx={{ color: "white", fontSize: "20px" }}
            >
              Fill the form to request for the Official Central Billing System
              Invoice ID
            </Typography>
          </Box>
        </Card>
      </Layout>
      {/* <Footer /> */}
    </div>
  );
};

export default RequsitionService;
